import ACTIONS from "./SettingsActionTypes";

//GET
export const getSettingsRequest = (payload) => ({
  type: ACTIONS.GET_SETTINGS_REQUEST,
  payload,
});

export const getSettingsResponse = (payload) => ({
  type: ACTIONS.GET_SETTINGS_RESPONSE,
  payload,
});

//POST
export const postSettingsRequest = (payload) => ({
  type: ACTIONS.POST_SETTINGS_REQUEST,
  payload,
});

export const postSettingsResponse = (payload) => ({
  type: ACTIONS.POST_SETTINGS_RESPONSE,
  payload,
});

export const postSettingsResponseClear = () => ({
  type: ACTIONS.POST_SETTINGS_RESPONSE_CLEAR,
});

//PUT
export const putSettingsRequest = (payload) => ({
  type: ACTIONS.PUT_SETTINGS_REQUEST,
  payload,
});

export const putSettingsResponse = (payload) => ({
  type: ACTIONS.PUT_SETTINGS_RESPONSE,
  payload,
});

//CUSTOM-ROLES

//GET ALL
export const getCustomRoleListRequest = (payload) => ({
  type: ACTIONS.GET_CUSTOM_ROLE_LIST_REQUEST,
  payload,
});

export const getCustomRoleListResponse = (payload) => ({
  type: ACTIONS.GET_CUSTOM_ROLE_LIST_RESPONSE,
  payload,
});

//GET
export const getCustomRoleRequest = (payload) => ({
  type: ACTIONS.GET_CUSTOM_ROLE_REQUEST,
  payload,
});

export const getCustomRoleResponse = (payload) => ({
  type: ACTIONS.GET_CUSTOM_ROLE_RESPONSE,
  payload,
});

//POST
export const postCustomRoleRequest = (payload) => ({
  type: ACTIONS.POST_CUSTOM_ROLE_REQUEST,
  payload,
});

export const postCustomRoleResponse = (payload) => ({
  type: ACTIONS.POST_CUSTOM_ROLE_RESPONSE,
  payload,
});

//PUT
export const putCustomRoleRequest = (payload) => ({
  type: ACTIONS.PUT_CUSTOM_ROLE_REQUEST,
  payload,
});

export const putCustomRoleResponse = (payload) => ({
  type: ACTIONS.PUT_CUSTOM_ROLE_RESPONSE,
  payload,
});

export const postCustomRoleResponseClear = (payload) => ({
  type: ACTIONS.POST_CUSTOM_ROLE_RESPONSE_CLEAR,
  payload,
});

//PUT STATUS
export const putCustomRoleStatusRequest = (payload) => ({
  type: ACTIONS.PUT_CUSTOM_ROLE_STATUS_REQUEST,
  payload,
});

export const putCustomRoleStatusResponse = (payload) => ({
  type: ACTIONS.PUT_CUSTOM_ROLE_STATUS_RESPONSE,
  payload,
});

//GET ROLE BY PERMISION
export const getCustomRoleByPermissionRequest = (payload) => ({
  type: ACTIONS.GET_ROLE_BY_PERMISSION_REQUEST,
  payload,
});

export const getCustomRoleByPermissionResponse = (payload) => ({
  type: ACTIONS.GET_ROLE_BY_PERMISSION_RESPONSE,
  payload,
});

//PUT ROLE BY PERMISSION
export const putCustomRoleByPermissionRequest = (payload) => ({
  type: ACTIONS.PUT_ROLE_BY_PERMISSION_REQUEST,
  payload,
});

export const putCustomRoleByPermissionResponse = (payload) => ({
  type: ACTIONS.PUT_ROLE_BY_PERMISSION_RESPONSE,
  payload,
});

export const putCustomRoleByPermissionResponseClear = () => ({
  type: ACTIONS.PUT_ROLE_BY_PERMISSION_RESPONSE_CLEAR,
});
